














#Documentation: https://longbill.github.io/jquery-date-range-picker/
require('../../vendor/jquery-date-range-picker/jquery.daterangepicker.min.js')
helpers = require('../../helpers.coffee')
on_clickaway = require('vue-clickaway')

module.exports = {
  mixins: [ on_clickaway.mixin ]
  props:
    id:
      default: ''

    full_period_option:
      default: false
    
    this_month:
      default: false

    this_today:
      default: false
  data: ->
    show_picker: false
    container: "#{@id}-container"
    options: @buildOptions()
    selected_option: null

  methods:
    buildOptions: ->
      options = [
        { value: { text: 'Data customizada', from: null, to: null }, text: 'Data customizada' }
        { value: { text: 'Hoje', from: new Date(), to: new Date() }, text: 'Hoje' }
        { value: { text: 'Ontem', from: @getYesterday(), to: @getYesterday() }, text: 'Ontem' }
        { value: { text: 'Essa semana', from: @getMonday(), to: new Date() }, text: 'Essa semana' }
        { value: { text: 'Esse mês', from: @getFirstDayMonth(new Date()), to: new Date() }, text: 'Esse mês' }
        { value: { text: 'Esse ano', from: @getFirstDayYear(new Date()), to: new Date() }, text: 'Esse ano' }
      ]
      options.unshift({ value: { text: 'Todo o período', from: null, to: null }, text: 'Todo o período' }) if @full_period_option
      options

    initialSelectedOption: ->
      return { value: { text: 'Todo o período', from: null, to: null }, text: 'Todo o período' } if @full_period_option
      return { value: { text: 'Esse mês', from: @getFirstDayMonth(new Date()), to: new Date() }, text: 'Esse mês' } if @this_month
      return { value: { text: 'Hoje', from: new Date(), to: new Date() }, text: 'Hoje' } if @this_today
      { value: { text: 'Essa semana', from: @getMonday(), to: new Date() }, text: 'Essa semana' }

    dropdownChanged: (value) ->
      @setSelectedOption(value)
      if @validDate(@date_from) && @validDate(@date_to)
        jQuery('#' + @id).data('dateRangePicker').setDateRange(@date_from._d, @date_to._d, true)
        @emitDate()
      else
        jQuery('#'+@id).data('dateRangePicker').clear()
        @emitDate() if @selected_option.text == 'Todo o período'

    calendarChanged: (obj) ->
      @setSelectedOption({ text: 'Data customizada', from: obj.date1, to: obj.date2 })
      @emitDate()

    setSelectedOption: (value) ->
      value.from = if @validDate(value.from) then moment(value.from)._d else '-'
      value.to = if @validDate(value.to) then moment(value.to)._d else '-'
      @selected_option = value

    validDate: (value) ->
      value && value != '-'

    formatDate: (value) ->
      if @validDate(value) then value.format('LL') else '-'

    toggleShowPicker: ->
      @show_picker = !@show_picker

    hidePicker: ->
      @show_picker = false

    getMonday: ->
      moment().weekday(1)._d

    getFirstDayMonth: (date) ->
      y = date.getFullYear()
      m = date.getMonth()
      firstDayMonth = new Date(y, m, 1)
      moment(firstDayMonth)._d

    getFirstDayYear: (date) ->
      y = date.getFullYear()
      m = date.getMonth()
      firstDayYear = new Date(y, 0, 1)
      moment(firstDayYear)._d

    getYesterday: ->
      moment().subtract(1,'d')._d

    initializeDatePicker:->
      jQuery('#'+@id).dateRangePicker({
        language: 'pt'
        startOfWeek: 'monday'
        hoveringTooltip: false
        inline:true,
        container: '#'+@id+'-container'
        alwaysOpen:true
        format: 'DD/MM/YYYY'
        separator: ' à '
        showTopbar: false
        autoClose: true
        endDate: moment().toDate()
      }).bind('datepicker-change', (event, obj) => @calendarChanged(obj) )

    emitDate: ->
      from = if @validDate(@selected_option.from) then @selected_option.from else null
      to = if @validDate(@selected_option.to) then @selected_option.to else null
      @$emit 'date-changed', { from: from, to: to }

  computed:
    date_from: ->
      if @validDate(@selected_option.from) then moment(@selected_option.from) else '-'

    date_to: ->
      if @validDate(@selected_option.to) then moment(@selected_option.to) else '-'

    selected_text: ->
      return @selected_option.text if @selected_option.text == 'Todo o período'
      return ' - ' if !@validDate(@date_from) && !@validDate(@date_to)
      return @selected_option.text if @selected_option.text != 'Data customizada'
      @date_from.format('D MMMM, YYYY') + ' - ' + @date_to.format('D MMMM, YYYY')

    isCalendarDisabled: ->
      @selected_option.text != 'Data customizada'

  created: ->
    @setSelectedOption(@initialSelectedOption().value)

  mounted: ->
    @initializeDatePicker()
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/date_range_picker.vue